var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h6>\n  <a href="'+
((__t=( lastPost.url ))==null?'':_.escape(__t))+
'" class="link link--topic qa-link-to-topic">'+
((__t=( title ))==null?'':_.escape(__t))+
'</a>\n  ';
 if (threadTitleIcon) { 
__p+='\n    <span class="thread-list-item-type-icon icon--auto-width icon--'+
((__t=( threadTitleIcon ))==null?'':_.escape(__t))+
'"></span>\n  ';
 } 
__p+='\n</h6>\n<ul class="list list--dot-seperated text--meta m-v-S">\n  ';
 if( lastPost.relativeCreationDate ){ 
__p+='\n  <li>\n    <span>'+
((__t=( lastPost.relativeCreationDate ))==null?'':_.escape(__t))+
'</span>\n  </li>\n  ';
 } 
__p+='\n\n  ';
 if( showCategory && forum.title ){ 
__p+='\n  <li>\n    <a href="'+
((__t=( forum.url ))==null?'':_.escape(__t))+
'" class="link">'+
((__t=( forum.title ))==null?'':_.escape(__t))+
'</a>\n  </li>\n  ';
 } 
__p+='\n</ul>\n';
}
return __p;
};
